import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedReorder202511: FaireAdPerformancePeriodEntity =
  {
    token: "perf_p4_under_utilized_reorder_202511",
    type: "adPerformancePeriod",
    scope: "REORDER_MARKETPLACE",
    periodType: "RECEIPT",
    startDate: "2025-11-01",
    endDate: "2025-11-30",
    impressions: 4373,
    clicks: 59,
    adsSpendDollars: 280,
    budgetDollars: 500,
    salesDollars: 5328,
    bestEstimateRoas: 19.03,
    bestEstimateType: "ACTUALIZED",
    budgetUtilization: 0.56,
    reorderConversions: 11,
    dataAvailableAtDate: "2025-12-04",
    meta: {
      source: "mock",
      importedAt: "2026-07-06T00:00:00.000Z",
      importedBy: "advertiser-profiles",
    },
  };
